import axios from 'axios';

axios.defaults.withCredentials = false; // withCredentials 전역 설정

const apiIp = document.getElementById("session_apiIp").value
const apiAxios = axios.create({
    withCredentials: false,
    baseURL : apiIp,
    headers: {'content-type': 'application/x-www-form-urlencoded'},
    timeout: 90000,
});

// if (haveAccessToken()) {
//     apiAxios.defaults.headers.common['Authorization'] = 'Bearer ' + getAccessToken();
// }

apiAxios.interceptors.request.use(
    function (config) {
        return Promise.resolve(config);
    },
    error => Promise.reject(error),
);

apiAxios.interceptors.response.use(
    // 응답 데이터를 가공하여 내보낸다
    response => {
        return response.data.resultData;
    },
    // 응답 데이터 에러 발생시
    function (error) {
        const originalRequest = error.config;
        if (error.response) {
            console.error(error)
            //     if (error.response.status === 401 && !originalRequest._retry) {
        //         return axios
        //             .get('/get_token?jwt_refresh=1')
        //             .then(res => {
        //                 if (res.data && res.data.data.jwt_access) {
        //                     const access_token = res.data.data.jwt_access;
        //                     console.log('[axios]success new token receive : ' + access_token);
        //                     setAccessToken(access_token);
        //                     originalRequest.headers['Authorization'] = 'Bearer ' + access_token;
        //                     return apiAxios(originalRequest);
        //                 } else {
        //                     return Promise.reject('재발급에러');
        //                 }
        //             })
        //             .catch(err => {
        //                 console.log('토큰 재발급 중 에러가 발생했습니다.');
        //                 console.log(err);
        //                 return Promise.reject(error);
        //             });
        //     } else {
        //         return Promise.reject(error);
        //     }
        }
        return Promise.reject(error);
    },
);

const axiosLoc = axios.create({
    withCredentials: false,
	baseURL: 'http://49.254.169.116:8090',
    headers: {'content-type': 'application/x-www-form-urlencoded'},
    timeout: 90000,
});

// if (haveAccessToken()) {
//     apiAxios.defaults.headers.common['Authorization'] = 'Bearer ' + getAccessToken();
// }

axiosLoc.interceptors.request.use(
    function (config) {
        return Promise.resolve(config);
    },
    error => Promise.reject(error),
);

axiosLoc.interceptors.response.use(
    // 응답 데이터를 가공하여 내보낸다
    response => {

        return response.data.resultData;
    },
    // 응답 데이터 에러 발생시
    function (error) {
        const originalRequest = error.config;
        if (error.response) {
            console.error(error)
            //     if (error.response.status === 401 && !originalRequest._retry) {
            //         return axios
            //             .get('/get_token?jwt_refresh=1')
            //             .then(res => {
            //                 if (res.data && res.data.data.jwt_access) {
            //                     const access_token = res.data.data.jwt_access;
            //                     console.log('[axios]success new token receive : ' + access_token);
            //                     setAccessToken(access_token);
            //                     originalRequest.headers['Authorization'] = 'Bearer ' + access_token;
            //                     return apiAxios(originalRequest);
            //                 } else {
            //                     return Promise.reject('재발급에러');
            //                 }
            //             })
            //             .catch(err => {
            //                 console.log('토큰 재발급 중 에러가 발생했습니다.');
            //                 console.log(err);
            //                 return Promise.reject(error);
            //             });
            //     } else {
            //         return Promise.reject(error);
            //     }
        }
        return Promise.reject(error);
    },
);

export {apiAxios, axiosLoc};